<template>
    <div>

        <section class="feature-section section-odd">
            <div class="container">
                <div class="row ">
                    <div class="col-lg-7 text-center">
                        <figure style="border: 1px #f2f2f2 solid">
<!--                          <img src="images/homepage/powerful-simplicity.png" width="100%"/>-->
                          <img src="images/homepage/schema-diff2.png" width="100%">
                        </figure>
                    </div>
                  <div class="col-lg-5 text-left p-r-30">
                    <h2 class="align-left">Evolve Schema Changes</h2>
                    <p>
                      Skippr auto-detects your data schemas from any source and optimises the output format for each of your destinations.
                    </p>
                    <p>
                      New columns, data type changes, nested data structures and common invalid/corrupt formatting are all auto-detected and handled at ingestion with Skippr in real-time.
                    </p>
                  </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    export default {
        name: 'SchemaDrift',
        props: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
